import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import EntityFilterProvider from '../entity-filter-provider/entity-filter-provider.vue';
const AutoFormGroup = () =>
  import('@shared/components/forms/auto-form/auto-form-group/auto-form-group.vue');

@Component({
  name: 'bpc-extended-filter',
  components: {
    'bpc-auto-form-group': AutoFormGroup,
    'bpc-entity-filter-provider': EntityFilterProvider,
  },
})
export default class ExtendedFilter extends Vue {
  $refs!: {
    filterProvider: InstanceType<typeof EntityFilterProvider> & {
      saveEntity(formModel: AnyEntity): void;
    };
    autoFormGroup: InstanceType<any> & {};
  };

  @Prop(String) readonly entity: string;
  @Prop({ type: String, default: 'extended' }) readonly filterConfigName: string;
  @Prop(Object) readonly value: AnyEntity;
  @Prop({ type: String, default: 'filter' }) readonly filterType: string;
  @Prop({ type: String, default: 'table' }) readonly storeName: string;
  @Prop(String) readonly configFileName: string;

  public filterModel: AnyEntity = {};

  public filterExcluded = ['sortedBy', 'orderBy', 'page', 'per_page', 'tenantAlias'];

  setFilterModel(filterModel) {
    Object.keys(filterModel).map((k, index) => {
      if (!this.filterExcluded.includes(k)) {
        this.$set(this.filterModel, k, filterModel[k]);
      }
    });
  }
  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }
}
